import { render, staticRenderFns } from "./choiceAfterSalesService.vue?vue&type=template&id=4237f190&scoped=true&"
import script from "./choiceAfterSalesService.vue?vue&type=script&lang=js&"
export * from "./choiceAfterSalesService.vue?vue&type=script&lang=js&"
import style0 from "./choiceAfterSalesService.vue?vue&type=style&index=0&id=4237f190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4237f190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4237f190')) {
      api.createRecord('4237f190', component.options)
    } else {
      api.reload('4237f190', component.options)
    }
    module.hot.accept("./choiceAfterSalesService.vue?vue&type=template&id=4237f190&scoped=true&", function () {
      api.rerender('4237f190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/choiceAfterSalesService.vue"
export default component.exports